import _keyBy from 'lodash/keyBy';

import ImageHotspotEditField from '@/modules/corporate/modules/questions/fields/image-hotspot/Field/Edit';
import MatchTheFollowingEditField from '@/modules/corporate/modules/questions/fields/match-the-following/Field/Edit';
import MultiSelectEditField from '@/modules/corporate/modules/questions/fields/multi-select/Field/Edit';
import PictureChoiceEditField from '@/modules/corporate/modules/questions/fields/picture-choice/Field/Edit';
import SingleSelectEditField from '@/modules/corporate/modules/questions/fields/single-select/Field/Edit';
import TrueFalseEditField from '@/modules/corporate/modules/questions/fields/true-or-false/Field/Edit';

import FillInTheBlanksEditField from './fill-in-the-blanks/Field/Edit';

export const ALL_EDIT_FIELDS = [
  SingleSelectEditField,
  MultiSelectEditField,
  TrueFalseEditField,
  PictureChoiceEditField,
  MatchTheFollowingEditField,
  FillInTheBlanksEditField,
  ImageHotspotEditField,
];

export const EditFields = _keyBy(ALL_EDIT_FIELDS, 'type');
